export const useDebounce = () => {
  const debounce = (callback: (...args: any[]) => any, debounce: number) => {
    let timerId: NodeJS.Timeout

    return (...args: any[]) => {
      clearTimeout(timerId)
      timerId = setTimeout(() => {
        callback(...args)
      }, debounce)
    }
  }

  return { debounce }
}